// Pagination
export const PAGINATION_PARAM_NAME = "page";

// Auth
export const CONNECT_NAV = "connect-nav";
export const CREATE_NAV = "create-nav";

// Unorg'd
export const SUBSET_PARAM_NAME = "subset";
export const MARKET_ID_PARAM_NAME = "id";
export const RETURN_PARAM_NAME = "return";
export const MODAL_PARAM_NAME = "modal";
export const OUTCOME_ID_PARAM_NAME = "outcomeId";
export const CREATE_MARKET_FORM_PARAM_NAME = "form";
export const CREATE_MARKET_PORTFOLIO = 'CREATE_MARKET_PORTFOLIO';
export const AFFILIATE_NAME = 'r'
